import { StepValidationState } from "../../../../../interfaces/step";
import { RegistrationNumberSearchReviewComponent } from "projects/reg-hub-client/src/app/orders/registration-number-search-review/registration-number-search-review.component";
import { RegistrationNumberSearchCriteriaComponent } from "projects/reg-hub-client/src/app/orders/registration-number-search-criteria/registration-number-search-criteria.component";
import { SearchStepper, eCriteriaVariation } from "../search-stepper";

export class ONRegistrationNumberSearchStepper extends SearchStepper {

    constructor() {
        super()
        this.configuration = [
            // eCriteriaVariation.FirstMiddleInitialLast,
            // eCriteriaVariation.DateOfBirth,
            // eCriteriaVariation.SearchFromDate,
            // eCriteriaVariation.SpecificNonSpecific,
            // eCriteriaVariation.ExactSimilar
        ];

        this.steps = [
            { title: "Search Criteria", content: RegistrationNumberSearchCriteriaComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: RegistrationNumberSearchReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}